import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=b0ff673e&scoped=true&"
import script from "./echarts.vue?vue&type=script&lang=js&"
export * from "./echarts.vue?vue&type=script&lang=js&"
import style0 from "./echarts.vue?vue&type=style&index=0&id=b0ff673e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ff673e",
  null
  
)

export default component.exports